import { aligmentCollection } from '@/constants/aligmentList'

export default ({ genderId, alignmentId }) => aligmentCollection[alignmentId].name[genderId].nominative
